import styled from '@emotion/styled';
import { Col } from 'antd';

export let StyledCol = styled(Col)`
  @media (max-width: 1100px) {
    width: 100%;
    max-width: 100%;
  }
`;
